import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {GiReturnArrow} from "react-icons/gi";
function ROrders() {

    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);
    const [status, ] = React.useState( null);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        let params = {
            count: 40,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            'processFor' : 'Sales',
            status_id:  14,
            returned : 1
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
                setIsLoaded(true);
                document.getElementById('body').classList.remove("toggle-sidebar");

            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

    }, [status]);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="returned-orders"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <GiReturnArrow className='ms-2' />
محموله های برگشتی
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4">

                                    <table className="table table-hover">
                                        <thead>
                                        <tr className='text-small-2 text-muted'>
                                            <th scope="col"># </th>
                                            <th scope="col">نماینده</th>
                                            <th scope="col">تعداد باتری</th>
                                            <th scope="col">کد پیگیری</th>
                                            <th scope="col">تاریخ ثبت</th>
                                            <th scope="col">وضعیت</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            orders.map (order => {
                                                return (
                                                    <tr  key={order.id}
                                                         role='button'
                                                         onClick={() => navigate(`/returned-orders/${order.id}`)}
                                                    >
                                                        <th scope="row">
                                                            {order.factor_number}
                                                        </th>
                                                        <td>
                                                            {order.vendor.title}
                                                            &nbsp;
                                                            <span
                                                                className='text-small-2 text-muted'>({order.vendor.city})</span>
                                                        </td>
                                                        <td>
                                                            {order.battery_qty}
                                                        </td>
                                                        <td>
                                                            {order.tracking_code}
                                                        </td>
                                                        <td className='text-small-2' >
                                                            {order.date}
                                                        </td>



                                                        <td
                                                            style={{color:order.last_status?.color}}
                                                            className='text-small-2'
                                                        >
                                                            {order.last_status?.title}
                                                        </td>
                                                    </tr>
                                                )} )
                                        }
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                        </div>



                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default ROrders;